import React from 'react';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import HeaderDropdownItem from '../../Components/Header/HeaderDropdown/HeaderDropdownItem';
import { UserProductType } from '../../../../types/product.types';

export interface ProductPickerItemProps {
	icon: React.JSX.Element;
	text: string;
	type: UserProductType;
	switchAction: () => void;
}

export const ProductPickerItem = ({
	text,
	icon,
	switchAction,
	...rest
}: ProductPickerItemProps) => (
	<HeaderDropdownItem
		_id={`product-picker-${text}`}
		cy={`product-picker-${text}`}
		switchAction={switchAction}
		closeMenu={() => {}}
		{...rest}>
		<ListItemIcon>
			<span style={{ width: 24, marginTop: 6 }}>{icon}</span>
		</ListItemIcon>
		<ListItemText>{text}</ListItemText>
	</HeaderDropdownItem>
);
